<template>
    <div
        class="modal fade text-left"
        :id="id"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel1">
                        <span v-if="userStore.agreementType==1">{{ localizationStore.translate('contract') }}</span>
                        <span v-else>{{ localizationStore.translate('power.of.attorney') }}</span>
                    </h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <span v-html="userStore.user.contract" v-if="userStore.agreementType==1"></span>
                    <span v-html="userStore.user.power_of_attorney" v-else></span>
                </div>
                <div class="modal-footer">
                    <button @click="closeModal(`#${id}`)" type="button" class="btn btn-primary">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
    import { useUserStore } from '../../stores/UserStore.js'

    export default {
        props: {
            id: String
        },
        mounted() {
        },
        setup(props) {
            return {
                closeModal: closeModal,
                localizationStore: useLocalizationStore(),
                userStore: useUserStore(),
            }
        },
    }
</script>